import { createAction } from 'redux-actions'

export const clearAllProgramsForPartner = createAction(
  'CLEAR_ALL_PROGRAMS_FOR_PARTNER'
)
export const clearPermanentAccountId = createAction(
  'CLEAR_PERMANENT_ACCOUNT_ID'
)
